export default __webpack_public_path__ + "11cbb20a58343c0601ee4737f36485d9.png";